import axios from 'axios';

export const getEnvironmentInformation = () => {
  return axios.get(axios.defaults.baseURL.replace('switch', '') + 'info');
};

export const getSettings = () => {
  return axios.get('settings');
};

export const getCategoriesWithProducts = () => {
  return axios.get('categories/products');
};

export const getLines = (buildProducts) => {
  if (!buildProducts) {
    throw new Error('buildProducts is missing in api.getLines()');
  }

  const postData = {
    selectedCategoryProducts: buildProducts,
  };

  return axios.post('color-type', postData);
};

export const getProductsGroupedByCategories = (
  lineId,
  selectedCategoryProductIds
) => {
  if (!lineId) {
    throw new Error('lineId is missing in api.getProducts()');
  }
  if (!selectedCategoryProductIds) {
    throw new Error(
      'selectedCategoryProductIds is missing in api.getProducts()'
    );
  }

  const urlParam = selectedCategoryProductIds.join(',');

  return axios.get(
    `color-type/${lineId}/products?selectedCategoryProductIds=${urlParam}`
  );
};

export const getMissingCategoryProductIdsFromBrand = (
  brandId,
  selectedCategoryProductIds,
  selectedColorId = null
) => {
  if (!brandId) {
    throw new Error(
      'brandId is missing in api.getMissingCategoryProductIdsFromBrand()'
    );
  }
  if (!selectedCategoryProductIds) {
    throw new Error(
      'selectedCategoryProductIds is missing in api.getMissingCategoryProductIdsFromBrand()'
    );
  }

  let urlParams = selectedCategoryProductIds.join(',');

  if (selectedColorId) {
    urlParams += `&selectedColorId=${selectedColorId}`;
  }

  return axios.get(
    `brand/${brandId}/missing-category-products?selectedCategoryProductIds=${urlParams}`
  );
};

export const getMissingCategoryProductIdsFromColor = (
  colorId,
  selectedCategoryProductIds,
  selectedBrandId = null
) => {
  if (!colorId) {
    throw new Error(
      'colorId is missing in api.getMissingCategoryProductIdsFromBrand()'
    );
  }
  if (!selectedCategoryProductIds) {
    throw new Error(
      'selectedCategoryProductIds is missing in api.getMissingCategoryProductIdsFromBrand()'
    );
  }

  let urlParams = selectedCategoryProductIds.join(',');

  if (selectedBrandId) {
    urlParams += `&selectedBrandId=${selectedBrandId}`;
  }

  return axios.get(
    `color/${colorId}/missing-category-products?selectedCategoryProductIds=${urlParams}`
  );
};

export const getRoomTypes = () => {
  return axios.get('room-types');
};

export const getWallTypes = () => {
  return axios.get('wall-types');
};

export const getInfoPopups = () => {
  return axios.get('info-popups');
};

export const makeRoom = (room) => {
  return axios.post('room/build/make', room);
};

export const getRooms = (roomUids) => {
  return axios.get('room/build/get', {
    params: {
      uids: roomUids,
    },
  });
};
